import React from 'react'

import { ExternalLink } from 'packages/common'
import { OrderedBathAmenities, OrderedBedAmenities } from 'packages/grimoire'
import { useI18n } from 'packages/i18n'
import { IconName } from 'packages/iconic'
import { getVacasaViewUnitURL } from 'packages/utils/links'

import { composeOrderedAmenityString } from 'app/fieldapp/components/schedule/components/CleanDetail/CleanDetail.helpers'
import {
  InfoRowLabel,
  Details,
  DetailIcon,
  SectionSubTitle,
  UnitInfoContainer,
} from 'app/fieldapp/components/schedule/components/TaskSharedStyles'
import { Slugs } from 'app/fieldapp/i18n'
import { Unit, UnknownUnit } from 'app/fieldapp/store/units'

const St = {
  DetailIcon,
  Details,
  InfoRowLabel,
  SectionSubTitle,
  UnitInfoContainer,
}

export type VisitHomeInfoProps = {
  unit: Unit
}

export const VisitHomeInfo: React.FC<VisitHomeInfoProps> = React.memo(
  ({ unit }) => {
    const { t, tp } = useI18n()

    const { amenities, bathrooms, beds, id } = unit || UnknownUnit

    const bedTypesString = composeOrderedAmenityString(
      OrderedBedAmenities,
      amenities,
      tp,
    )
    const bathTypesString = composeOrderedAmenityString(
      OrderedBathAmenities,
      amenities,
      tp,
    )

    return (
      <St.UnitInfoContainer>
        <St.DetailIcon icon={IconName.home} size={16} />
        <St.Details>
          <St.SectionSubTitle>{t(Slugs.homeInfo)}</St.SectionSubTitle>

          <div>
            <St.InfoRowLabel>{tp(Slugs.bed, beds)}</St.InfoRowLabel>
            {bedTypesString && ` (${bedTypesString})`}
          </div>

          <div>
            <St.InfoRowLabel>{tp(Slugs.bath, bathrooms)}</St.InfoRowLabel>
            {bathTypesString && ` (${bathTypesString})`}
          </div>

          <div>
            <St.InfoRowLabel>{t(Slugs.maxOccupancy)}</St.InfoRowLabel>
            {` ${unit?.maxOccupancy}`}
          </div>

          <ExternalLink
            text={t(Slugs.viewHome)}
            url={getVacasaViewUnitURL(id)}
          />
        </St.Details>
      </St.UnitInfoContainer>
    )
  },
)
